export default "__VITE_ASSET__Bsn0_EDS__"